import { getOfflineDb } from '../offline/dbFactory'
import { ensureOfflineReady } from '../offline/initOffline'
import { enqueueEntityChange } from '../offline/outbox/entityOutbox'
import { dexieFarmRepo } from '../offline/repos/DexieFarmRepo'
import {
  buildQueuedEntityMutationResult,
  type EntityMutationResult,
  type EntityMutationSyncState
} from './entityMutationSync'
import { writeCurrentFarm, type WizardFarm } from './farmWizard'

export type FarmMutationResult = EntityMutationResult<WizardFarm>

export const readFarmMutationSyncState = async (farmId: string): Promise<EntityMutationSyncState> => {
  const pendingCount = await getOfflineDb().entityOutbox
    .where('[entityType+entityId]')
    .equals(['farm', farmId])
    .count()

  return pendingCount > 0 ? 'pending' : 'synced'
}

export const upsertFarm = async (farm: WizardFarm): Promise<FarmMutationResult> => {
  await ensureOfflineReady()
  await dexieFarmRepo.upsert(farm)
  await enqueueEntityChange({
    entityType: 'farm',
    op: 'upsert',
    entityId: farm.id,
    payload: {
      id: farm.id,
      name: farm.name,
      altitude: farm.altitude,
      location: (farm as any).location,
      metadata: farm.metadata
    }
  })
  writeCurrentFarm(farm)

  return buildQueuedEntityMutationResult(farm, {
    entityType: 'farm',
    entityId: farm.id,
    maxEntries: 10
  })
}